module.exports = __webpack_public_path__ + "static/media/Fourth-Floor.1558caa1.png";